export default __webpack_public_path__ + "static/logo-ea4bfdfb259b538703e6b0a435db2a12.png";